import React from "react";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import NeedsAttentionIcon from "@mui/icons-material/NotificationImportant";
import PendingIcon from "@mui/icons-material/Pending";
import CompleteIcon from "@mui/icons-material/CheckCircle";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import TodayIcon from '@mui/icons-material/Today';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import DateRangeIcon from '@mui/icons-material/DateRange';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import AlarmOffIcon from '@mui/icons-material/AlarmOff';

import { Link } from "react-router-dom";

const StudiesSubNavigation = ({ open, org, active, hasSchedule }) => (
  <Collapse in={open} timeout="auto" unmountOnExit>
    <Box ml={2}>
      <List component="div" disablePadding>
        <ListItem disablePadding>
          <ListItemButton component={Link} to={`/clinic/today`} selected={active === 'today'}>
            <ListItemIcon>
              <TodayIcon />
            </ListItemIcon>
            <ListItemText primary="Today" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={Link} to={`/clinic/yesterday`} selected={active === 'yesterday'}>
            <ListItemIcon>
              <EventRepeatIcon />
            </ListItemIcon>
            <ListItemText primary="Yesterday" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={Link} to={`/clinic/week`} selected={active === 'week'}>
            <ListItemIcon>
              <DateRangeIcon />
            </ListItemIcon>
            <ListItemText primary="Past Week" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={Link} to={`/clinic/all`} selected={active === 'all'}>
            <ListItemIcon>
              <CalendarMonthIcon />
            </ListItemIcon>
            <ListItemText primary="All" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={Link} to={`/clinic/attention`} selected={active === 'attention'}>
            <ListItemIcon>
              <NeedsAttentionIcon />
            </ListItemIcon>
            <ListItemText primary="Needs Attention" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={Link} to={`/clinic/pending`} selected={active === 'pending'}>
            <ListItemIcon>
              <PendingIcon />
            </ListItemIcon>
            <ListItemText primary="Pending" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={Link} to={`/clinic/complete`} selected={active === 'complete'}>
            <ListItemIcon>
              <CompleteIcon />
            </ListItemIcon>
            <ListItemText primary="Complete" />
          </ListItemButton>
        </ListItem>
        {hasSchedule && (<>
          <ListItem disablePadding>
            <ListItemButton component={Link} to={`/clinic/unscheduled`} selected={active === 'unscheduled'}>
              <ListItemIcon>
                <AlarmOffIcon />
              </ListItemIcon>
              <ListItemText primary="Unscheduled" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton component={Link} to={`/clinic/scheduled`} selected={active === 'scheduled'}>
              <ListItemIcon>
                <AccessAlarmIcon />
              </ListItemIcon>
              <ListItemText primary="Scheduled" />
            </ListItemButton>
          </ListItem>
        </>)}
      </List>
    </Box>
  </Collapse>
);

export default StudiesSubNavigation;
